// extracted by mini-css-extract-plugin
export default {"custom-dropdown":"CategoryTemplate_custom-dropdown__k4Z8O"};